import { render, staticRenderFns } from "./BaseFileFieldDisplay.vue?vue&type=template&id=47759382&scoped=true"
import script from "./BaseFileFieldDisplay.vue?vue&type=script&lang=js"
export * from "./BaseFileFieldDisplay.vue?vue&type=script&lang=js"
import style0 from "./BaseFileFieldDisplay.vue?vue&type=style&index=0&id=47759382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47759382",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
